module.exports = __webpack_public_path__ + "static/media/carousel-prods.0a43fa5f.png";